import axios from "axios";

function getOrCreateToken() {
  let token = localStorage.getItem("token");

  if (!token || token === "null" || token === "undefined") {
    token = crypto.randomUUID();
    localStorage.setItem("token", token);
  }

  return token;
}

const middleware = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || window.location.origin,
  headers: {
    "Authorization": "Fingerprint " + getOrCreateToken(),
  },
});

const data = response => response.data;

export const CampaignApi = {
  async getByUuid(uuid) {
    return middleware.get(`/api/campaigns/${uuid}`).then(data);
  },
}

export const VoteApi = {
  async make(payload) {
    return middleware.post('api/votes', payload).then(data);
  }
}
